import { render } from "./MailingEditComponent.vue?vue&type=template&id=8bc8e2aa&scoped=true"
import script from "./MailingEditComponent.vue?vue&type=script&lang=js"
export * from "./MailingEditComponent.vue?vue&type=script&lang=js"

import "./MailingEditComponent.vue?vue&type=style&index=0&id=8bc8e2aa&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc8e2aa"]])

export default __exports__